// extracted by css-extract-rspack-plugin
module.exports =  {"template-37":"Template37-MfwW__template-37"};